import Frame from "./../Frame";
import { getFrameAbsoluteUrl } from "../resourceUrls";
import { ComponentType } from "../types";

export default class ComponentFrame extends Frame {

    constructor(controllerId, componentName: ComponentType, options) {
        super(getFrameAbsoluteUrl('component.html'), controllerId, {componentName, options});
    }

    _createIframe(params) {
        if (typeof params.componentName !== 'string' && params.componentName.trim() === '') {
            return null;
        }

        let iframe = super._createIframe(params);
        iframe.setAttribute('title', params.componentName.trim());

        let styles = {
            border: "none",
            margin: "0",
            padding: "0",
            width: "1px",
            "min-width": "100%",
            overflow: "hidden",
            display: "block",
            height: params?.options?.height || "24px",
        };

        iframe.style.cssText = Object.keys(styles).map(function (style) {
            return style + ": " + styles[style] + " !important;"
        }).join(" ");

        return iframe;
    }
}